import { NotificationPage as Data } from '@/typings/api/NotificationPage'
import { dateFormatter } from '@/helpers/dateFormatter'
import {
  DELETE, EDIT, VIEW, OPEN_NEW_TAB,
} from '@/helpers/enums/table-actions'

export const TABLE_ACTIONS = Object.freeze([
  EDIT,
  VIEW,
  OPEN_NEW_TAB,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: false,
    width: '60px',
  },
  {
    text: 'Наименование',
    value: 'title',
    sortable: false,
  },
  {
    text: '',
    value: 'is_public',
    sortable: false,
    width: '20px',
  },
  {
    text: 'Статус',
    value: 'public_status',
    sortable: false,
    field: (v: boolean) => (v ? 'Доступно всем' : 'Доступно авторизованным пользователям'),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: false,
    width: 144,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата обновления',
    value: 'updated_at',
    sortable: true,
    width: 144,
    field: (value: Data['updated_at']) => (
      (value && dateFormatter(value)) || '-'
    ),
  },
])
